import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from 'assets/img/customer/06.png';
import _imports_1 from 'assets/img/customer/01.png';
import _imports_2 from 'assets/img/customer/02.png';
import _imports_3 from 'assets/img/customer/03.png';
import _imports_4 from 'assets/img/customer/04.png';
import _imports_5 from 'assets/img/customer/05.png';
const _withScopeId = n => (_pushScopeId("data-v-9e754156"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "customer"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"item title\" data-v-9e754156></div><div class=\"item\" data-v-9e754156><div class=\"service-network\" data-v-9e754156><div class=\"map\" data-v-9e754156></div><div class=\"info\" data-v-9e754156><h1 data-v-9e754156>江苏 · 连云港</h1><img src=\"" + _imports_0 + "\" alt=\"\" data-v-9e754156><div class=\"label\" data-v-9e754156>地址</div><p data-v-9e754156>连云港市赣榆经济开发区和安中小企业园</p><div class=\"label\" data-v-9e754156>电话</div><p data-v-9e754156><a href=\"tel:051882096658\" data-v-9e754156>0518-82096658</a></p></div></div></div><div class=\"item solution\" data-v-9e754156><h2 data-v-9e754156>服务解决方案</h2><p data-v-9e754156>我们致力于通过保持设备和软件的可持续性和可靠性来帮助您提高性能和可用性。</p><p data-v-9e754156>请直接向新万格服务团队寻求电话技术支持和远程问题解决方案。</p></div>", 3);
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tab-img",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-info"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "在线服务"), /*#__PURE__*/_createElementVNode("h4", null, "用心提供专业服务")]), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "24小时x365天售后服务热线快速响应客户需求"), /*#__PURE__*/_createElementVNode("li", null, "四级服务网络，遍布全国的服务团队提供专业技术支持"), /*#__PURE__*/_createElementVNode("li", null, "热情贴心的客户呼叫中心提供真诚的电话回访关怀"), /*#__PURE__*/_createElementVNode("li", null, "服务全程严格遵守ISO9001和ISO13485质量管理体系规范作业")])], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tab-img",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-info"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "保修服务"), /*#__PURE__*/_createElementVNode("h4", null, "2小时响应客户需求"), /*#__PURE__*/_createElementVNode("h4", null, "生命周期内享受终身维护")]), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "维修方式： 现场维修、寄件维修、返厂维修、办事处维修。"), /*#__PURE__*/_createElementVNode("li", null, " 延长保修： 用户可以通过延保来降低产品的维护成本和使用风险。耗材，附件以及部分模块等不适用于此延保项目。具体的延保报价，请咨询新万格相应区域的工程师。 ")])], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tab-img",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-info"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "增值服务"), /*#__PURE__*/_createElementVNode("h4", null, "多层次全方位从客户角度着想，提供多样化服务")]), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, " 对于 VIP 客户，我们将针对新万格仪器产品进行定期巡访，对设备进行针对性的预防维护，可有效减少设备故障率，延长设备使用寿命。 "), /*#__PURE__*/_createElementVNode("li", null, " 为客户提供培训班服务，定期对医院人员进行临床应用与维护培训，提升产品应用熟练程度，降低临床应用风险。 ")])], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tab-img",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-info"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "客户培训"), /*#__PURE__*/_createElementVNode("h4", null, "我们为客户提供专业、灵活、全面的培训！")]), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "终端客户培训，为客户提供专业的现场培训；"), /*#__PURE__*/_createElementVNode("li", null, "渠道商培训，为渠道商提供全面的培训，带来更好的客户体验；"), /*#__PURE__*/_createElementVNode("li", null, "在线培训，灵活的方式可以随时随地学习！")])], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tab-img",
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-info"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "产品/网络安全"), /*#__PURE__*/_createElementVNode("h4", null, "如今，智慧医疗迎来风口，医疗数据的互联互通正在为临床决策提供更有效、更全面的支持。")]), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, " 贯穿整个产品生命周期的风险控制程序，以确保在每个环节都能预防网络安全风险及正确识别网络安全问题。 "), /*#__PURE__*/_createElementVNode("li", null, " 支持基于标准消息格式（如 HL7、DICOM 和 GDT）的信息集成，严格按照 IHE 标准设计程序交互性。 ")])], -1));
const _hoisted_15 = {
  class: "sec-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "contact-us"
}, "联系我们", -1));
import ContactForm from "./components/contactForm.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
        title: "客户",
        "title-en": "The customer",
        "bg-url": require('assets/img/customer/top.png')
      }, null, 8, ["bg-url"]), _hoisted_2, _createVNode(_component_el_tabs, {
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "在线服务"
        }, {
          default: _withCtx(() => [_hoisted_5, _hoisted_6]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "保修服务"
        }, {
          default: _withCtx(() => [_hoisted_7, _hoisted_8]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "增值服务"
        }, {
          default: _withCtx(() => [_hoisted_9, _hoisted_10]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "客户培训"
        }, {
          default: _withCtx(() => [_hoisted_11, _hoisted_12]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "产品/网络安全"
        }, {
          default: _withCtx(() => [_hoisted_13, _hoisted_14]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(ContactForm)])]);
    };
  }
});